import { createRoot } from "react-dom/client";
import { applyWide, readWide } from "./lib/prefs";
import "./fonts.css";
import { App } from "./App";

applyWide(readWide());

createRoot(document.getElementById("root")!).render(<App />);
